import * as React from "react";
const MoreDotIcon = (props: any) => (
  <svg
    width="current"
    height="current"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1319_27209"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={20}
    >
      <rect width={20} height={20} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1319_27209)">
      <path
        d="M9.99564 15.391C9.69652 15.391 9.44192 15.2845 9.23185 15.0714C9.02178 14.8584 8.91675 14.6024 8.91675 14.3032C8.91675 14.0041 9.02326 13.7495 9.23627 13.5395C9.44928 13.3294 9.70535 13.2244 10.0045 13.2244C10.3036 13.2244 10.5582 13.3309 10.7683 13.5439C10.9783 13.7569 11.0834 14.013 11.0834 14.3121C11.0834 14.6112 10.9769 14.8658 10.7639 15.0759C10.5508 15.2859 10.2948 15.391 9.99564 15.391ZM9.99564 11.0833C9.69652 11.0833 9.44192 10.9768 9.23185 10.7638C9.02178 10.5508 8.91675 10.2947 8.91675 9.99557C8.91675 9.69645 9.02326 9.44185 9.23627 9.23178C9.44928 9.02171 9.70535 8.91668 10.0045 8.91668C10.3036 8.91668 10.5582 9.02318 10.7683 9.2362C10.9783 9.44921 11.0834 9.70528 11.0834 10.0044C11.0834 10.3035 10.9769 10.5581 10.7639 10.7682C10.5508 10.9783 10.2948 11.0833 9.99564 11.0833ZM9.99564 6.77561C9.69652 6.77561 9.44192 6.66911 9.23185 6.45609C9.02178 6.24308 8.91675 5.98701 8.91675 5.68788C8.91675 5.38876 9.02326 5.13416 9.23627 4.92409C9.44928 4.71404 9.70535 4.60901 10.0045 4.60901C10.3036 4.60901 10.5582 4.71552 10.7683 4.92853C10.9783 5.14154 11.0834 5.39761 11.0834 5.69674C11.0834 5.99586 10.9769 6.25045 10.7639 6.46051C10.5508 6.67058 10.2948 6.77561 9.99564 6.77561Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);
export default MoreDotIcon;
